import type { StyleProp, ViewStyle } from "react-native";
import { Text, type TextProps } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type CustomListSubheaderProps = {
	enableGutters?: boolean;
	children: React.ReactNode;
	font?: string;
	adjustsFontSizeToFit?: boolean;
	style?: StyleProp<ViewStyle>;
	textVariant?: TextProps<Text>["variant"];
};
export const CustomListSubheader = ({
	children,
	enableGutters = true,
	adjustsFontSizeToFit = false,
	textVariant = "titleSmall",
	...rest
}: CustomListSubheaderProps) => {
	const theme = useAppTheme();
	return (
		<Box
			paddingHorizontal={enableGutters ? 16 : 0}
			gap={16}
			style={{
				paddingVertical: 18,
			}}
			{...rest}
		>
			<Text
				adjustsFontSizeToFit={adjustsFontSizeToFit}
				style={{ color: theme.colors.onSurface }}
				variant={textVariant}
			>
				{children}
			</Text>
		</Box>
	);
};
